/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Grid, Typography, Avatar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  border: '1px solid rgba(255, 255, 255, 0.3)',
  borderRadius: '5px',
  display: 'flex',
  py: 2,
  px: 2,
};

export const EmployeeBadge = (props) => {
  return (
    <Grid item xs={6}>
      <Grid sx={style}>
        <Avatar sx={{ width: 40, height: 40, mr: 2 }} />
        <Grid>
          <Typography
            sx={{ lineHeight: '1', fontWeight: 500 }}
            margin={0}
            variant="subtitle1"
          >
            {props.name}
          </Typography>
          <Typography variant="caption">{props.jobTitle}</Typography>
        </Grid>
        {props.removeIcon ? (
          <IconButton sx={{ ml: 'auto' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
};
